module.exports = __webpack_public_path__ + "img/landing_icon_3.b2edfcd0.svg";